module.exports = __webpack_public_path__ + "media/images/wind-2dd7ca5a.png";